import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ThemeModule } from '../../@theme/theme.module';
import { NbLayoutModule, NbCardModule, NbAlertModule, NbButtonModule, NbCheckboxModule, NbInputModule, NbSpinnerModule } from '@nebular/theme';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { RequestPasswordComponent } from './request-password/request-password.component';
import { LogoutComponent } from './logout/logout.component';
import { VerifycodeComponent } from './verifycode/verifycode.component';
import {PipesModule} from "../../pipes/pipes.module";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,

        ThemeModule,

        NbLayoutModule,
        NbCardModule,
        NbAlertModule,
        NbInputModule,
        NbButtonModule,
        NbCheckboxModule,
        NbSpinnerModule,
        PipesModule,
    ],
	declarations: [
		LoginComponent,
		ResetPasswordComponent,
		RequestPasswordComponent,
		RegisterComponent,
		LogoutComponent,
		VerifycodeComponent,
	],
})
export class AuthModule {
}
